import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/stack-exchange': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M17.7 332.3h412.7v22c0 37.7-29.3 68-65.3 68h-19l-86.8 89.7v-89.7h-176.3c-36 0-65.3-30.3-65.3-68v-22zM17.7 308.7v-85h412.7v85h-412.7zM17.7 199.3v-85h412.7v85h-412.7zM365 0c36 0 65.3 30.3 65.4 67.7v22.3h-412.7v-22.3c0-37.4 29.3-67.7 65.3-67.7h282z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/stack-exchange.js
// module id = 1031
// module chunks = 0